import { render, staticRenderFns } from "./SkuInfoItemOne.vue?vue&type=template&id=5f8e420f&scoped=true"
import script from "./SkuInfoItemOne.vue?vue&type=script&lang=js"
export * from "./SkuInfoItemOne.vue?vue&type=script&lang=js"
import style0 from "./SkuInfoItemOne.vue?vue&type=style&index=0&id=5f8e420f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e420f",
  null
  
)

export default component.exports